import axios from "axios";
import { backUrl } from "../utils/backURL";
const API_URL = backUrl;

/**
 * Crea un nuevo log en el sistema
 * @param {Object} logData - Datos del log a crear
 * @param {string} logData.action - Acción realizada
 * @param {string} logData.details - Detalles adicionales o tipo de log (info, error, warning)
 * @param {string} logData.user_name - Nombre del usuario que realiza la acción
 * @param {string} logData.orderId - ID de la orden asociada al log
 * @param {string} clientId - ID del cliente
 * @returns {Promise<Object>} - Respuesta de la API
 */
export const createLog = async (logData, clientId) => {
  try {
    // Asegurarse de que todos los campos sean strings y estén formateados correctamente
    const formattedLogData = {
      action: String(logData.action || "").trim(),
      details: String(logData.details || "").trim(),
      user_name: String(logData.user_name || "").trim(),
      orderId: String(logData.orderId || "").trim(),
      step: String(logData.step || "").trim()
    };

    // Validar que ningún campo esté vacío
    Object.entries(formattedLogData).forEach(([key, value]) => {
      if (!value) {
        console.warn(`El campo ${key} está vacío en el log a crear`);
      }
    });
    console.log(formattedLogData, "formattedLogData");
    const response = await axios.post(
      `${API_URL}/workflows/p2p/${clientId}/logs`,
      formattedLogData,
      {
        headers: {
          "Content-Type": "application/json"
        }
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error al crear log:", error);
    throw error;
  }
};

/**
 * Obtiene todos los logs asociados a una orden específica
 * @param {string} clientId - ID del cliente
 * @param {string} orderId - ID de la orden
 * @returns {Promise<Array>} - Array con los logs de la orden
 */
export const getLogsByOrderId = async (clientId, orderId) => {
  try {
    const response = await axios.get(
      `${API_URL}/workflows/p2p/${clientId}/logs/${orderId}`,
      {
        headers: {
          "Content-Type": "application/json"
        }
      }
    );

    return response.data;
  } catch (error) {
    console.error(`Error al obtener logs para la orden ${orderId}:`, error);
    throw error;
  }
};